export const SkeletonSmerInner = () => {
  return (
    <>
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="skeleton h-44"></div>
        <div className="skeleton h-44"></div>
        <div className="skeleton h-44"></div>
        <div className="skeleton h-44"></div>
      </div>
      <div className="mt-6 flex gap-2 md:mt-8">
        <div className="skeleton h-8 w-28"></div>
        <div className="skeleton h-8 w-28"></div>
        <div className="skeleton h-8 w-28"></div>
        <div className="skeleton h-8 w-28"></div>
        <div className="skeleton h-8 w-28"></div>
      </div>
      <div className="mt-6 flex gap-2 md:mt-8">
        <div className="skeleton h-36 w-40"></div>
        <div className="skeleton h-36 w-40"></div>
        <div className="skeleton h-36 w-40"></div>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 md:mt-8">
        <div className="skeleton h-44"></div>
        <div className="skeleton h-44"></div>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-4 md:mt-8">
        <div className="skeleton h-44"></div>
        <div className="skeleton h-44"></div>
      </div>
    </>
  );
};
